module.exports = __webpack_public_path__ + "static/media/home-service-slider-7.22d33770.jpg";